module.exports = __webpack_public_path__ + "static/img/6.8dfe160.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/eng/6.png
// module id = NW4g
// module chunks = 0